import "./OurRhythm.module.css";
import Header from "@/reusable_sections/Header";
import WeeklyRhythm from "./sections/WeeklyRhythm";
import ServiceProjects from "./sections/ServiceProjects";
import Footer from "@/reusable_sections/Footer";
export default function OurRhythmPage() {
  return <div>
      <Header />
      <WeeklyRhythm />
      <ServiceProjects />
      <Footer />
    </div>;
}